// extracted by mini-css-extract-plugin
export default {"announcement":"announcement__Unc7iw","icon":"icon__QlzWKH","iconText":"iconText__cvxbgZ","toolbar":"toolbar__f651VY"};